/** Device position helpers for «Usar mi ubicación» (plan §4.1). */

export interface IDevicePosition {
  lat: number;
  lng: number;
}

export const DEVICE_POSITION_TIMEOUT_MS = 10_000;

/** The device position (high accuracy, 10 s); rejects when unavailable, denied or timed out. */
export function getDevicePosition(
  timeoutMs = DEVICE_POSITION_TIMEOUT_MS
): Promise<IDevicePosition> {
  return new Promise((resolve, reject) => {
    const geolocation =
      typeof navigator === 'undefined' ? undefined : navigator.geolocation;
    if (!geolocation) {
      reject(new Error('Geolocation unavailable'));
      return;
    }
    geolocation.getCurrentPosition(
      (position) =>
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        }),
      (error) => reject(error),
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 0 }
    );
  });
}

/**
 * Whether the location permission is already granted, so asking for the
 * position shows no prompt. `navigator.permissions` is missing below Safari 16:
 * false there, and on any error.
 */
export async function isGeolocationGranted(): Promise<boolean> {
  try {
    const permissions =
      typeof navigator === 'undefined' ? undefined : navigator.permissions;
    if (!permissions || typeof permissions.query !== 'function') return false;
    const status = await permissions.query({ name: 'geolocation' });
    return status.state === 'granted';
  } catch {
    return false;
  }
}
